/**
 * @class Oskari.mapframework.bundle.coordinatetool.CoordinateToolService
 */
Oskari.clazz.define('Oskari.mapframework.bundle.coordinatetool.CoordinateToolService',
/**
 * @method create called automatically on construction
 * @static
 */
function (sandbox, config) {
  this._sandbox = sandbox;
  this._config = config;
  this._reverseGeocodingIds = config.reverseGeocodingIds;
  this.urls = {};
  this.urls.reverseGeocode = Oskari.urls.getRoute('GetReverseGeocodingResult');
}, {
  __name: 'CoordinateTool.CoordinateToolService',
  __qname: 'Oskari.mapframework.bundle.coordinatetool.CoordinateToolService',
  getQName: function getQName() {
    return this.__qname;
  },
  getName: function getName() {
    return this.__name;
  },
  /**
  * Initializes the service (does nothing atm).
  *
  * @method init
  */
  init: function init() {},
  /**
  * Returns the url to request reverse geocoding result
  *
  * @method getReverseGeocodeUrl
  * @return {String}
  */
  _getReverseGeocodeUrl: function _getReverseGeocodeUrl(lon, lat) {
    var url = this.urls.reverseGeocode + '&epsg=' + this._sandbox.getMap().getSrsName() + '&lon=' + lon + '&lat=' + lat;
    if (this._reverseGeocodingIds) {
      // '&scale=' + this._sandbox.getMap().getScale();
      url += '&channel_ids=' + this._reverseGeocodingIds + '&scale=5000';
    }
    return url;
  },
  /**
  * Retrieves retreaves reverse geocoding result to input lon, lat
  *
  * @method getReverseGeocode
  * @param  {Function} successCb
  * @param  {Function} errorCb (optional)
  * @param  {String/Number} lon (east coordinate)
  * @param  {String/Number} lat (north coordinate)
  * @param  {String} id (optional)
  */
  getReverseGeocode: function getReverseGeocode(successCb, errorCb, lon, lat, id) {
    var me = this,
      url = me._getReverseGeocodeUrl(lon, lat);
    if (id) {
      url += '&id=' + id;
    }
    jQuery.ajax({
      url: url,
      type: 'GET',
      dataType: 'json',
      success: function success(response) {
        if (response) {
          me._handleResponse(response, successCb);
        }
      },
      error: function error(jqXHR, textStatus) {
        if (typeof errorCb === 'function' && jqXHR.status !== 0) {
          errorCb(jqXHR, textStatus);
        }
      }
    });
  },
  _handleResponse: function _handleResponse() {
    var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var cb = arguments.length > 1 ? arguments[1] : undefined;
    if (typeof cb !== 'function' || !response.locations) {
      return;
    }
    var result = response.locations.map(function (location) {
      return {
        channelId: location.channelId,
        name: location.name,
        type: location.type
      };
    });
    cb(result);
  }
}, {
  'protocol': ['Oskari.mapframework.service.Service']
});